sw-in-grid-content {
  grid-column: span 2;
  grid-row: span 2;
  
  @media (max-width: 1024px) {
    grid-row: span unset;
    aspect-ratio: 4 / 5;
  }

  .promo-card {
    position: relative; 
    width: 100%; 
    height: 100%; 
    min-height: 250px; 
    padding: var(--promo-tile-padding)!important;
    
    @media (max-width: 1024px) {
      padding: calc(var(--promo-tile-padding) * var(--promo-tile-responsive-modifier));
    }

    [slot="media"] {
      
      > img, > video {
        object-fit: cover;
        width: 100%; 
        height: 100%; 
        position: absolute; 
        top: 0; 
        left: 0; 
        z-index: 1;
      }

    }

    [slot="text"] {
      position: absolute; 
      bottom: var(--promo-tile-padding);
      left: var(--promo-tile-padding);
      z-index: 2; 
      display: flex; 
      flex-direction: column; 
      justify-content: flex-end;
      align-items: flex-start;
      height: 100%;
      width: 100%;
      
      @media (max-width: 1024px) {
        bottom: calc(var(--promo-tile-padding) * var(--promo-tile-responsive-modifier));
        left: calc(var(--promo-tile-padding) * var(--promo-tile-responsive-modifier));
        width: unset;
      }

      &.light-infill {
      
        a, h3, h5, p {
          color: white;
        }

        a::before {
          background: white;
        }

      }
      
      &.dark-infill {
  
        a, h3, h5, p {
          color: black;
        }

        a::before {
          background: black;
        }
  
      }
  
      a {
        position: relative;
        transition: all .5s;
        
        &::before {
          content: '';
          position: absolute;
          height: 2px;
          width: 0;
          bottom: -4px;
          left: 0;
          transition: all .5s;
        }
        
        &:hover {
          transition: all .5s;
          
          &::before {
            transition: all .5s;
            width: 100%;
          }

        }

      }

      h3, h5, a, p {
        padding: 0;
        margin: 0 0 var(--promo-tile-item-spacing) 0;
        font-family: var(--font-base);
        
        @media (max-width: 1024px) {
          margin: 0 0 calc(var(--promo-tile-item-spacing) * var(--promo-tile-responsive-modifier)) 0;
        }

      }

      h5 {
        font-size: var(--promo-tile-secondary-title-size);
        
        @media (max-width: 1024px) {
          font-size: calc(var(--promo-tile-secondary-title-size) * var(--promo-tile-responsive-modifier));
        }

      }

      h3 {
        font-size: var(--promo-tile-primary-title-size);
        
        @media (max-width: 1024px) {
          font-size: calc(var(--promo-tile-primary-title-size) * var(--promo-tile-responsive-modifier));
        }

      }

      p, a {
        font-size: var(--promo-tile-text-size);
        
        @media (max-width: 1024px) {
          font-size: calc(var(--promo-tile-text-size) * var(--promo-tile-responsive-modifier));
        }

      }
      
    }

  }

}